import { useQuery } from "@tanstack/vue-query";

export function useIPGeolocation() {
  return useQuery({
    queryKey: ["ip-geolocation"],
    queryFn: async () => {
      const res = await $fetch("/api/ip-geolocation");
      return res;
    },
  }).data;
}
